module.exports = __webpack_public_path__ + "4ccbf30a7f9e8e271b5ecee2245fe31c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-5.png
// module id = 3160
// module chunks = 0